import React from "react";
import { Control, Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TextField, Box } from "@mui/material";
import { Calendar } from "assets/icons";
import { CalendarIcon } from "assets/icons";
import clsx from "clsx";
import styles from "./ui-date-field.module.scss";
import { ErrorMessage } from "shared/ui/ErrorMessage/ErrorMessage";
import { Dayjs } from "dayjs";

export type UiSelectOption = {
  value: string;
  label: string;
};

export type UiSelectFieldProps = {
  className?: string;
  label?: string;
  error?: any;
  options?: UiSelectOption[];
  control?: Control<any, any>;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  maxDate?: Date | Dayjs | undefined;
  minDate?: Date | Dayjs | undefined;
};

export function UiDatetField({
  className,
  error,
  label,
  control,
  name,
  placeholder,
  disabled,
  maxDate,
  minDate,
}: UiSelectFieldProps) {
  const id = label! + Math.random();

  return (
    <Box className={clsx(className, styles.dateWrapper)}>
      {label && (
        <label style={{ height: "17px" }} htmlFor={id}>
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, value = null },
          fieldState: { error },
        }) => {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                components={{
                  OpenPickerIcon: disabled ? Calendar : CalendarIcon,
                }}
                inputFormat="DD.MM.YYYY"
                value={value}
                disabled={disabled}
                maxDate={maxDate}
                minDate={minDate}
                componentsProps={{
                  actionBar: {
                    actions: ["clear"],
                    style: { justifyContent: "flex-start" },
                  },
                }}
                onChange={(event) => {
                  onChange(event);
                }}
                renderInput={({ ...params }) => {
                  return (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder,
                        autoComplete: "off",
                      }}
                      size="small"
                      focused={!!error}
                      error={!!error}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "12px",
                          border: "2px solid #C0D4E3",
                        },
                        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #0090D1",
                        },
                        "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #d32f2f",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #C0D4E3 !important",
                        },
                        "& .MuiInputBase-input": {
                          fontFamily: "Raleway",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "24px",
                          color: "#3E444A",
                          padding: "8px 12px",
                          "&::placeholder": {
                            fontFamily: "Raleway",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  );
                }}
              />
              {error && <ErrorMessage error={error?.message} />}
            </LocalizationProvider>
          );
        }}
      />
    </Box>
  );
}
